import React from 'react';
import styled, { css } from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import * as LucideIcons from 'lucide-react';

const NavWrapper = styled.nav`
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    background-color: ${({ theme }) => theme.colors.backgroundLight};
    border-top: 1px solid ${({ theme }) => theme.colors.borderColor};
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    z-index: 1000;
    padding: 0 10px;
    padding-bottom: env(safe-area-inset-bottom, 0);

    @media (min-width: 769px) {
        display: none;
    }
`;

const NavItem = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    flex: 1;
    height: 100%;
    color: ${({ theme, $isActive }) => $isActive ? theme.colors.primary : theme.colors.textDisabled};
    transition: all 0.2s ease-in-out;
    position: relative;
    padding-top: 5px;

    svg {
        width: 24px;
        height: 24px;
        margin-bottom: 4px;
        transition: transform 0.2s ease-in-out;
    }

    span {
        font-size: 0.7rem;
        font-weight: 500;
        display: ${({ $showLabel }) => ($showLabel ? 'block' : 'none')};
    }

    &:hover {
        color: ${({ theme }) => theme.colors.primaryDark};
    }

    ${({ $isCentral, theme }) => $isCentral && css`
        transform: translateY(-20px);
        background-color: ${theme.colors.primary};
        color: white;
        border-radius: 50%;
        width: 60px;
        height: 60px;
        min-width: 60px;
        flex-grow: 0;
        box-shadow: ${theme.shadows.lg};
        border: 4px solid ${theme.colors.backgroundLight};

        &:hover {
            background-color: ${theme.colors.primaryDark};
            color: white;
        }

        svg {
            width: 28px;
            height: 28px;
            margin: 0;
        }

        span {
            display: none;
        }
    `}
`;

const BottomNavBar = ({ config }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const renderIcon = (iconName) => {
        const IconComponent = LucideIcons[iconName];
        return IconComponent ? <IconComponent /> : <LucideIcons.HelpCircle />;
    };

    if (!config || config.length === 0) {
        return null;
    }

    return (
        <NavWrapper>
            {config.map(item => {
                const isActive = location.pathname === item.path;
                return (
                    <NavItem
                        key={item.actionId}
                        onClick={() => navigate(item.path)}
                        $isActive={isActive}
                        $isCentral={item.isCentral}
                        $showLabel={item.showLabel && !item.isCentral} // **POPRAWKA**
                        aria-label={item.label}
                    >
                        {renderIcon(item.iconName)}
                        <span>{item.label}</span>
                    </NavItem>
                );
            })}
        </NavWrapper>
    );
};

export default BottomNavBar;